import FooterComponent from "../../components/Footers/Footer";

const FootersPage = () => {
	const title = "Footers Examples";
	return (
		<div className="w-full flex flex-col gap-y-8 flex-wrap items-center justify-center">
			<div className="max-w-3xl text-center space-y-4">
				<div className="space-y-3">
					<div className="flex items-center justify-center gap-2 mb-2">
						<div className="w-1 h-1 rounded-full bg-amber-400 animate-pulse"></div>
						<span className="text-xs uppercase tracking-widest text-amber-400 font-semibold">Page Sections</span>
						<div className="w-1 h-1 rounded-full bg-amber-400 animate-pulse"></div>
					</div>
					<h1 className="text-5xl font-bold bg-gradient-to-r from-amber-400 via-blue-400 to-amber-400 bg-clip-text text-transparent">
						{title}
					</h1>
				</div>
				<p className="text-slate-400 text-base md:text-lg leading-relaxed">
					Page footer patterns with navigation, links, and info sections. Many styles to choose from.
				</p>
				<div className="flex items-center justify-center gap-2 pt-2">
					<div className="px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/30">
						<span className="inline-flex items-center gap-1 text-xs text-amber-300">
							<svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
								<path d="M12 3l1.9 4.1L18 9l-4.1 1.9L12 15l-1.9-4.1L6 9l4.1-1.9L12 3z" />
							</svg>
							Multi-section
						</span>
					</div>
					<div className="px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/30">
						<span className="inline-flex items-center gap-1 text-xs text-blue-300">
							<svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
								<path d="M13 2L4 14h6l-1 8 9-12h-6z" />
							</svg>
							Mobile-ready
						</span>
					</div>
				</div>
			</div>
			<div className="hover-lift">
				<FooterComponent />
			</div>
		</div>
	);
};

export default {
	page: FootersPage,
};


